import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import Service from '../../core/service'

export const getScoreDistribution = createAsyncThunk(
  'portfolio/summary/getScoreDistribution',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getScoreDistribution(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportScoreDistribution = createAsyncThunk(
  'portfolio/summary/exportScoreDistribution',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.exportScoreDistribution(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)
